import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      evaultToastMixin_toasts: []
    }
  },
  created () {
    this.evaultToastMixin_toasts = this.toasts
  },
  computed: {
    ...mapGetters(['toasts']),
    evaultToastMixin_activeToasts () {
      return this.evaultToastMixin_toasts.filter(toast => toast.active === true)
    }
  },
  watch: {
    '$store.state._toasts' () {
      this.evaultToastMixin_toasts = this.toasts
    }
  }
}
